import { Typography } from "@material-ui/core";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import useStyles from "./styles";
import OpenInNewTabIconHelper from "../StyledMaterialUI/OpenInNewTabHelper";

function AcceptTerms() {
  const classes = useStyles();
  const url = t({
    id: "app.accept-terms.url",
    message: "https://www.crisistextline.org/privacy/",
  });
  const ariaLabel = t({
    id: "app.accept-terms.aria-label",
    message: "Terms of Service and Privacy Policy (opens in a new tab)",
  });
  const linkText = t({
    id: "app.accept-terms.link-text",
    message: "Terms",
  });

  return (
    <Typography className={classes.agreeText}>
      {/* @ts-ignore */}
      <Trans id="app.accept-terms.text-before">
        By continuing, you accept our
      </Trans>{" "}
      <a
        color="secondary"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.termsAndConditionsText}
        aria-label={ariaLabel}
        style={{ backgroundColor: "transparent" }}
      >
        {linkText}
        <OpenInNewTabIconHelper />
      </a>
      .
    </Typography>
  );
}

export default AcceptTerms;
